<template>
  <div class="border border-gray-200 rounded-md bg-white dark:bg-gray-900 dark:border-gray-800 overflow-hidden" :class="statusClasses">
    <div class="overflow-hidden">
      <template v-for="option in options">
        <o-collapse
          :key="option.label"
          :visible="option.visible"
          header-class="flex items-center w-full px-3 py-2 border-b dark:border-gray-800 cursor-pointer"
        >
          <template #header>
            <div class="flex flex-grow items-start">
              <div class="w-1/4 flex-shrink-0 text-xs opacity-60">
                {{ $t(option.label) }}
              </div>
              <div class="flex-grow text-sm">
                {{ option.valueLabel() }}
              </div>
            </div>
          </template>
          <div class="bg-gray-100 dark:bg-gray-900 overflow-hidden">
            <component
              :is="option.component"
              v-model="_value[option.key]"
              v-bind="option.props"
              :options="option.items"
              :search="option.search"
              :selectCategory="option.selectCategory"
              group
              class="h-80"
            />
          </div>
        </o-collapse>
      </template>
    </div>
    <div class="flex flex-grow items-start px-3 py-2">
      <div class="w-1/4 flex-shrink-0 text-xs opacity-60">
        {{ $t('components.customer.list.fieldsWithDateRange.during') }}
      </div>
      <div class="flex-grow ">
        <date-range-optional-field
          v-model="_value.date"
          group
          :icon="false"
          container-class="flex items-center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import classes from '@/mixins/fields/classes.js'
import {
  DateRangeOptionalField,
  CheckboxGroupField,
  CheckboxCategoriesField,
} from '@/components/fields'

export default {
  components: {
    DateRangeOptionalField,
    CheckboxGroupField,
    CheckboxCategoriesField,
  },
  mixins: [classes],
  props: {
    options: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    defaultStatusClass: {
      type: [String, Object, Array],
      default: 'bg-white',
    },
    warningStatusClass: {
      type: [String, Object, Array],
      default: 'border-yellow-400 bg-yellow-100 dark:bg-yellow-400/20',
    },
    errorStatusClass: {
      type: [String, Object, Array],
      default: 'border-red-300 bg-red-100 dark:bg-red-400/20',
    },
    successStatusClass: {
      type: [String, Object, Array],
      default: 'border-green-300 bg-green-100 dark:bg-green-400/20',
    },
  },
  data () {
    return {
      currentValue: null,
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('update:value', value)
      },
    },
  },
  mounted () {
    this.currentValue = this.value
  },
}
</script>
